import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useLocation, useParams, useNavigate } from "react-router";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { ThemeControls } from "ui-kit/ThemeControl";
import { Routes } from "constants/routes";
import { DeviceSize } from "constants/deviceSize";
import { LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import ThemeStore from "stories/ThemeStore";
import UserStore from "stories/UserStore";
import { ThemeName } from "types/theme";
import { Logo } from "ui-kit/Logo";
import { Divider } from "ui-kit/Divider";
import { MenuItem } from "./MenuItem";
import { UserAccordion } from "./UserAccordion";
import { NewReleaseSubMenu } from "./NewReleaseSubMenu";
import { AnalyticsSubMenu } from "./AnalyticsSubMenu";
import Analytics from "assets/analytics.svg";
import Artists from "assets/artists.svg";
import Authors from "assets/authors.svg";
import General from "assets/general.svg";
import Labels from "assets/labels.svg";
import Releases from "assets/releases.svg";
import Tracks from "assets/tracks.svg";
import Vector from "assets/Vector.svg";
import BotRow from 'assets/botRow.svg'
import Support from "assets/support.svg";
import LibraryIcon from "assets/Library.svg";
import { ProfileSettingsModal } from "./ProfileSettingsModal";
import { SupportModal } from "components/Header/SupportModal";
import { CreateReleaseButton } from "ui-kit/Button";

interface SidebarProps {
  isMobileDrawer?: boolean;
}

export const Sidebar: React.FC<SidebarProps> = observer(({ isMobileDrawer }) => {
  const theme = ThemeStore.activeTheme;
  const user = UserStore.user;
  const title = `${user?.firstname ?? ''} ${user?.lastname ?? ''}`;
  const subtitle =
    user?.display_name && user.display_name.trim()
      ? user.display_name.trim()
      : "Your Nickname";
  const avatar = user?.avatar_url ?? null;
  const { pathname } = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true)
  const [openDet, setOpenDet] = useState(false)
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  useEffect(()=>{
    setOpen(true)
  },[pathname])

  return (
    <Container
      $isMobileDrawer={isMobileDrawer}
      style={{
        width: open ? "295px" : "67px",
        padding: open ? "22px 19px 19px 19px" : "22px 8px 16px 8px",
      }}
    >
      <Header>
        <LogoButton
          type="button"
          onClick={() => navigate(Routes.General)}
        >
          <Logo open={open} />
        </LogoButton>
        <CloseBox onClick={() => setOpen(!open)} style={{ right: open ? '-29px' : '-20px' }}>{open ? <><Vector /> <Vector /> </> : <VectorBox ><Vector /> <Vector /></VectorBox>}</CloseBox> </Header>
      <Content>
        <UserAccordion
          title={title}
          subtitle={subtitle}
          avatar={avatar}
          open={open}
          onSettingsClick={() => setIsProfileModalOpen(true)}
        />
        <SidebarCreateReleaseButton
          type="button"
          onClick={() => {
            localStorage.setItem("type", "");
            localStorage.setItem("newReleaseFrom", "releases");
            navigate(`/releases/new-release?step=type`);
          }}
        >
          <FormattedMessage
            id="Sidebar.CreateRelease"
            defaultMessage="Create a release"
            description="Create a release"
          />
        </SidebarCreateReleaseButton>
        <MenuItem path={Routes.Releases} isActive={Routes.Releases === pathname || `${Routes.Releases}/${id}` === pathname} icon={<Releases color={theme.palette.icon.primary} />}>
          <MenuItemBox>
            <FormattedMessage
              id="MenuItem.Releases"
              defaultMessage="Releases"
              description="Releases"
            />
            <div onClick={(ev) => {
              ev.stopPropagation();
              ev.preventDefault();
              setOpenDet(!openDet);
            }} style={{ height: '100%', width: '70px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: '3px' }}>
              {openDet ? <> <VectorBox ><BotRow /></VectorBox>  </> : <BotRow />}</div>

          </MenuItemBox>
        </MenuItem>
        {openDet && <>
          <MenuItem path={Routes.Tracks} isActive={Routes.Tracks === pathname || `${Routes.Tracks}/${id}` === pathname} icon={<Tracks color={theme.palette.icon.primary} />}>
            <FormattedMessage
              id="MenuItem.Tracks"
              defaultMessage="Tracks"
              description="Tracks"
            />
          </MenuItem>
          <MenuItem path={Routes.Artists} isActive={Routes.Artists === pathname || `${Routes.Artists}/${id}` === pathname} icon={<Artists color={theme.palette.icon.primary} />}>
            <FormattedMessage
              id="MenuItem.Artists"
              defaultMessage="Artists"
              description="Artists"
            />
          </MenuItem>

          <MenuItem path={Routes.Labels} isActive={Routes.Labels === pathname} icon={<Labels color={theme.palette.icon.primary} />}>
            <FormattedMessage
              id="MenuItem.Labels"
              defaultMessage="Labels"
              description="Labels"
            />
          </MenuItem>

          <MenuItem path={Routes.Authors} isActive={Routes.Authors === pathname || `${Routes.Authors}/${id}` === pathname} icon={<Authors color={theme.palette.icon.primary} />}>
            <FormattedMessage
              id="MenuItem.Authors"
              defaultMessage="Authors"
              description="Authors"
            />
          </MenuItem>
        </>}
        {pathname.includes(Routes.NewRelease.replace('/:id?', '')) && open && <NewReleaseSubMenu />}

        {/*<MenuItem icon={<Authors color={theme.palette.icon.primary} />}>*/}
        {/*  <FormattedMessage*/}
        {/*    id="MenuItem.Authors"*/}
        {/*    defaultMessage="Authors"*/}
        {/*    description="Authors"*/}
        {/*  />*/}
        {/*</MenuItem>*/}
        {/*<MenuItem icon={<Labels color={theme.palette.icon.primary} />}>*/}
        {/*  <FormattedMessage*/}
        {/*    id="MenuItem.Labels"*/}
        {/*    defaultMessage="Labels"*/}
        {/*    description="Labels"*/}
        {/*  />*/}
        {/*</MenuItem>*/}

        {/* <Divider $margin={22} />
        <MenuItem path={Routes.Authors} isActive={Routes.Authors === pathname || `${Routes.Authors}/${id}` === pathname} icon={<Authors color={theme.palette.icon.primary} />}>
         <FormattedMessage
            id="MenuItem.Authors"
            defaultMessage="Authors"
            description="Authors"
          />
        </MenuItem> */}
        <MenuItem
          path={Routes.Library}
          isActive={Routes.Library === pathname || `${Routes.Library}/${id}` === pathname}
          icon={<LibraryIcon />}
        >
         <FormattedMessage
            id="MenuItem.Library"
            defaultMessage="Library"
            description="Library"
          />
        </MenuItem>
        <Divider $margin={22} />
        {/* <MenuItem
        {/*<MenuItem
          path={Routes.Analytics}
          isActive={Routes.Analytics === pathname}
          icon={<Analytics color={theme.palette.icon.primary} />}
        >
          
          <FormattedMessage
            id="MenuItem.Analytics"
            defaultMessage="Analytics"
            description="Analytics"
          />
        </MenuItem> */}
        {/*{pathname.includes(Routes.Analytics) && <AnalyticsSubMenu />}*/}
        {/*<MenuItem icon={<Analytics color={theme.palette.icon.primary} />}>*/}
        {/*  <FormattedMessage*/}
        {/*    id="MenuItem.Analytics"*/}
        {/*    defaultMessage="Analytics"*/}
        {/*    description="Analytics"*/}
        {/*  />*/}
        {/*</MenuItem>*/}
        {/*<MenuItem icon={<Support color={theme.palette.icon.primary} />}>*/}
        {/*  <FormattedMessage*/}
        {/*    id="MenuItem.Support"*/}
        {/*    defaultMessage="Support"*/}
        {/*    description="Support"*/}
        {/*  />*/}
        {/*</MenuItem>*/}

      </Content>
      <Bottom>
        <SupportButton type="button" onClick={() => setIsSupportOpen(true)}>
          <Support color={theme.palette.icon.primary} />
          <SupportLabel>
            <FormattedMessage
              id="MenuItem.Support"
              defaultMessage="Support"
              description="Support"
            />
          </SupportLabel>
        </SupportButton>
        <ThemeControls
          checked={ThemeStore.activeThemeName === ThemeName.Dark}
          onChangeTheme={ThemeStore.setTheme}
          open={open}
        />
      </Bottom>
      <ProfileSettingsModal
        open={isProfileModalOpen}
        onClose={() => setIsProfileModalOpen(false)}
      />
      <SupportModal open={isSupportOpen} onClose={() => setIsSupportOpen(false)} />
    </Container>
  );
});

const Container = styled.div<{ $isMobileDrawer?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: ${({ $isMobileDrawer }) => ($isMobileDrawer ? "0" : "20px")};
  background-color: ${props => props.theme.palette.background.primary};
  transition: width 0.3s ease-in-out;
  // overflow: hidden
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
  min-height: 0;
  overflow-y: auto;
   &::-webkit-scrollbar {
    display: none;
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 8px 4px 8px;
`;

const SupportButton = styled.button`
  width: 100%;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #111827;

  @media (min-width: ${DeviceSize.TabletMedium}) {
    display: none;
  }
`;

const SupportLabel = styled.span`
  flex: 1;
  text-align: left;
`;

const SidebarCreateReleaseButton = styled(CreateReleaseButton)`
  width: 100%;
  margin: 8px 0 4px 0;
  font-size: 13px;
  padding: 8px 12px;
  min-height: 35px;
  @media (min-width: ${DeviceSize.TabletMedium}) {
    display: none;
  }
`;

const LogoutButton = styled.button`
  width: 100%;
  border: 1px solid rgba(248, 113, 113, 0.6);
  background: rgba(248, 250, 252, 0.9);
  color: #b91c1c;
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;

  &:hover {
    background: #fee2e2;
    box-shadow: 0 4px 10px rgba(248, 113, 113, 0.35);
    transform: translateY(-0.5px);
  }
`;

const LogoutLabel = styled.span`
  white-space: nowrap;
`;

const Header = styled.div`
  position:relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoButton = styled.button`
  width:100%;
  border: none;
  padding: 0;
  margin: 0;
  background: transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CloseBox = styled.div`
  position:absolute; 
  width: 27px;
  height: 27px;
  border-radius:50%;
  background:rgba(255, 255, 255, 1);
  box-shadow: 1px 1px 4px 1px rgba(178, 178, 178, 0.49);
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;

  @media (max-width: ${DeviceSize.TabletMedium}) {
    display: none;
  }
`
const VectorBox = styled.div`
  rotate:180deg;
  display:flex;
  justify-content: center;
  align-items: center;
`

const MenuItemBox = styled.div`
  width:100%;
  display:flex;
  justify-content: space-between;
  align-items: center
`